export default {
  setDocumentsData(state, documents) {
    state.documents = documents;
  },
  setDocumentsSignedData(state, documents) {
    state.documentsSigned = documents;
  },
  setDocumentsPendingData(state, documents) {
    state.documentsPending = documents;
  },
  setDocumentsRejectedData(state, documents) {
    state.documentsRejected = documents;
  },
  setDocumentsInvitedData(state, documents) {
    state.documentsInvited = documents;
  },
  setDocumentsInvitedSigned(state, documents) {
    state.documentsInvitedSigned = documents;
  },
  setDocumentsInvitedPending(state, documents) {
    state.documentsInvitedPending = documents;
  },
  setDocumentsArchived(state, documents) {
    state.documentsArchived = documents;
  }
}
